var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event)}}},_vm._l((_vm.options),function(item){return _c('el-radio',{key:item.id,attrs:{"label":item.id}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }